import React, { useState, forwardRef, useEffect } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import TOSTab from "./PrepareTabs/TOSTab";
import PrepareTab from "./PrepareTabs/PrepareTab";
import PreOfferVerificationDocument from "./PreOfferVerificationDocument";
import { getPreOfferVerificationByJobIdAndCandidateId } from "../../helpers/backend_helper";
import { uploadPreOfferFilesReset } from "../../store/actions";

const PreparePreOfferVerification = forwardRef(
  (
    {
      setOffcanvasForm,
      jobTimeLineData,
      readOnly = false,
      edit = false,
      candidateId,
    },
    ref
  ) => {
    const dispatch = useDispatch();

    const [activeTab, setActiveTab] = useState("1");
    const [povId, setPovId] = useState(null);
    const [formSubmissionData, setFormSubmissionData] = useState(null);

    const uploadPreofferDocsMeta = useSelector(
      (state) => state.JobStageReducer.uploadPreofferDocsMeta
    );

    useEffect(() => {
      // Get Pre Offer Verification Submission Data
      if (jobTimeLineData && !povId) {
        getPreOfferVerificationByJobIdAndCandidateId(
          jobTimeLineData?.job?.id,
          jobTimeLineData?.candidate?.id
        ).then((response) => {
          setPovId(response?.data?.id);
          if (edit) {
            setFormSubmissionData(
              response?.data?.preOfferVerificationSubmissionData
            );
          }
        });
        dispatch(uploadPreOfferFilesReset());
      }
    }, [jobTimeLineData, uploadPreofferDocsMeta?.isSuccess]);

    return (
      <React.Fragment>
        <div
          className="d-flex flex-column justiy-content-between h-100 p-3"
          style={{ height: "500px" }}
        >
          <Nav tabs>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "1" })}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveTab("1")}
              >
                Terms of Service (ToS)
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === "2" })}
                style={{ cursor: "pointer" }}
                onClick={() => setActiveTab("2")}
              >
                Attachments
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="1" className="pt-2">
              <TOSTab jobTimeLineData={jobTimeLineData} />
            </TabPane>
            <TabPane tabId="2">
              <PrepareTab
                setOffcanvasForm={setOffcanvasForm}
                jobTimeLineData={jobTimeLineData}
                povId={povId}
                formSubmissionData={formSubmissionData}
                readOnly={readOnly}
                edit={edit}
                ref={ref}
              />
              <PreOfferVerificationDocument
                candidateId={candidateId}
                jobTimeLineData={jobTimeLineData}
                povId={povId}
                formSubmissionData={formSubmissionData}
                readOnly={readOnly}
                edit={edit}
              />
            </TabPane>
          </TabContent>
        </div>
      </React.Fragment>
    );
  }
);

export default PreparePreOfferVerification;
